import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { X as XIcon, Copy, Check } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';

const APP_ORIGIN = 'https://app.toolshare.no';

interface Props {
  code: string;
  title: string;
  onClose: () => void;
}

export const QRCodeSheet: React.FC<Props> = ({ code, title, onClose }) => {
  const [copied, setCopied] = useState(false);
  const url = `${APP_ORIGIN}/?code=${encodeURIComponent(code)}`;

  const handleCopy = async () => {
    try { await navigator.clipboard.writeText(url); } catch {}
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return ReactDOM.createPortal(
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 400, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 20, padding: '28px 24px 24px', width: '100%', maxWidth: 340, textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 14, right: 14, width: 32, height: 32, borderRadius: '50%', border: 'none', background: '#f1f5f4', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#5b6864' }}>
          <XIcon size={16} strokeWidth={2} />
        </button>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#0f1e19', marginBottom: 4 }}>{title}</div>
        <div style={{ fontSize: 12, color: '#6b7a75', marginBottom: 18 }}>Skann med kameraet, eller bruk koden manuelt</div>
        <div style={{ display: 'inline-block', padding: 16, background: '#fff', border: '1px solid #e5e9e7', borderRadius: 12, marginBottom: 16 }}>
          <QRCodeSVG value={url} size={200} level="M" />
        </div>
        <div style={{ fontFamily: 'monospace', fontSize: 26, fontWeight: 700, letterSpacing: 4, color: '#0f1e19', marginBottom: 16 }}>
          {code}
        </div>
        <button onClick={handleCopy} style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid #d7dedb', background: copied ? '#e7f7ee' : '#f7f9f8', color: copied ? '#16a34a' : '#334', fontSize: 14, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
          {copied ? <><Check size={14} strokeWidth={2.5} /> Lenke kopiert</> : <><Copy size={14} strokeWidth={2} /> Kopier lenke</>}
        </button>
      </div>
    </div>,
    document.body
  );
};
